import { render, staticRenderFns } from "./ProductImageUploads.vue?vue&type=template&id=73579b9e&scoped=true"
import script from "./ProductImageUploads.vue?vue&type=script&lang=js"
export * from "./ProductImageUploads.vue?vue&type=script&lang=js"
import style0 from "./ProductImageUploads.vue?vue&type=style&index=0&id=73579b9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73579b9e",
  null
  
)

export default component.exports